import * as clientService from "../services/client.service";
import { NotificationToaster } from "../utils/notificationToaster";

const addAssignedClient = (client) => (dispatch, getState) => {
  const { assignedClient } = getState().wizard;
  const payload = {
    ...assignedClient,
    ...client,
  };
  dispatch({ type: "ASSIGNED_CLIENT_SUCCESS", payload });
};

const updateAssignedClient = (clientId, data) => (dispatch, getState) => {
  const { assignedClient } = getState().wizard;
  const payload = {
    userID: clientId,
    clientComment: !!data.clientComment ? data.clientComment.trim() : "",
  };

  if (assignedClient?.clientComment !== payload?.clientComment) {
    return clientService
      .updateClientNote(payload)
      .then((response) => {
        const clientData = {
          ...assignedClient,
          clientComment: !!data.clientComment ? data.clientComment.trim() : "",
          carePlanId: response?.carePlanID ?? response?.carePlanId,
        };

        dispatch({ type: "UPDATE_ASSIGNED_CLIENT", payload: clientData });
        // success
        return Promise.resolve();
      })
      .catch((err) => {
        dispatch({
          type: "UPDATE_ASSIGNED_CLIENT_ERROR",
          payload: err.message,
        });
        NotificationToaster({
          message: "Something went wrong",
          type: "error",
        });
        return Promise.reject();
      });
  } else {
    // should not call an api if prev value is equal to next value
    return Promise.resolve();
  }
};

export { addAssignedClient, updateAssignedClient };
